module.exports = __webpack_public_path__ + "static/media/App.76ee2a75.webp";